module.exports = __webpack_public_path__ + "static/media/OGG-mobile-types-2a.6f8a53a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-mobile-types-2a.jpg
// module id = 603
// module chunks = 0